import { useState } from "react";
import { createPortal } from "react-dom";
import { useStore, type Toast } from "../../store/useStore";
import { Icon } from "./Icon";
import { IconBtn, portalRoot } from "./primitives";

const TONE: Record<string, string> = { success: "good", error: "error", info: "teal", warn: "warn" };
const ICONS: Record<string, string> = { success: "check-circle", error: "warning-circle", info: "info", warn: "warning" };

function ToastCard({ t, onClose }: { t: Toast; onClose: () => void }) {
  const lang = useStore((s) => s.lang);
  const [copied, setCopied] = useState(false);
  const tone = TONE[t.type] ?? "teal";
  const ic = ICONS[t.type] ?? "info";
  const col = `var(--${tone === "teal" ? "accent-text" : tone})`;
  const copy = () => {
    if (!t.copy) return;
    void navigator.clipboard?.writeText(t.copy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    });
  };
  return (
    <div
      className="glass-strong anim-slide-r"
      style={{ borderRadius: 14, padding: "13px 15px", boxShadow: "var(--shadow-lg)", display: "flex", gap: 11, alignItems: "flex-start", borderLeft: `3px solid ${col}` }}
    >
      <Icon name={ic} size={19} weight="fill" style={{ color: col, marginTop: 1 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: 14, fontWeight: 600 }}>{t.msg}</p>
        {t.detail && (
          <p className={t.mono ? "font-mono" : ""} style={{ fontSize: 12, color: "var(--text-mute)", marginTop: 3, wordBreak: "break-word" }}>
            {t.detail}
          </p>
        )}
        {t.copy && (
          <button
            onClick={copy}
            style={{ marginTop: 7, fontSize: 11.5, fontWeight: 600, color: copied ? "var(--good)" : "var(--accent-text)", background: "none", border: "none", cursor: "pointer", display: "flex", alignItems: "center", gap: 5 }}
          >
            <Icon name={copied ? "check" : "copy"} size={13} />
            {copied ? (lang === "de" ? "Kopiert!" : "Copied!") : lang === "de" ? "Meldung kopieren" : "Copy message"}
          </button>
        )}
      </div>
      <IconBtn icon="x" size={14} box={24} onClick={onClose} />
    </div>
  );
}

export function Toaster() {
  const toasts = useStore((s) => s.toasts);
  const removeToast = useStore((s) => s.removeToast);
  return createPortal(
    <div style={{ position: "fixed", right: 20, bottom: "calc(20px + var(--safe-bottom))", zIndex: 400, display: "flex", flexDirection: "column", gap: 10, maxWidth: 400 }}>
      {toasts.map((t) => (
        <ToastCard key={t.id} t={t} onClose={() => removeToast(t.id)} />
      ))}
    </div>,
    portalRoot(),
  );
}
